export type StripeErrorCode =
  | 'incomplete_cvc'
  | 'incomplete_expiry'
  | 'incomplete_number'
  | 'incorrect_number'
  | 'invalid_cvc'
  | 'invalid_expiry_year_past'
  | 'invalid_number'
  | 'unknown_error';

export interface StripeError {
  code: StripeErrorCode;
}

export function getStripeErrorCode(error: unknown): StripeErrorCode {
  if (typeof error !== 'object' || error === null || !('code' in error)) {
    return 'unknown_error';
  }

  switch (error.code) {
    case 'incomplete_cvc':
    case 'incomplete_expiry':
    case 'incomplete_number':
    case 'incorrect_number':
    case 'invalid_cvc':
    case 'invalid_expiry_year_past':
    case 'invalid_number':
      return error.code;
    default:
      return 'unknown_error';
  }
}
